import React, { memo } from 'react';
import { DatePicker } from './DatePicker';
import type { FilterDateRangeProps } from '../FilterPanel.types';

function FilterDateRangeComponent({ config, value, onChange }: FilterDateRangeProps): React.ReactElement {
  const handleStartChange = (date: Date | null) => {
    onChange({
      start: date,
      end: value?.end || null
    });
  };

  const handleEndChange = (date: Date | null) => {
    onChange({
      start: value?.start || null,
      end: date
    });
  };

  return (
    <div>
      <label style={{
        display: 'block',
        fontSize: 'var(--text-xs)',
        fontWeight: 500,
        color: 'var(--color-text-secondary)',
        marginBottom: 'var(--space-1)'
      }}>
        {config.label}
      </label>
      <div style={{
        display: 'flex',
        gap: 'var(--space-2)',
        alignItems: 'center'
      }}>
        <div style={{ flex: 1 }}>
          <DatePicker
            value={value?.start || null}
            onChange={handleStartChange}
            maxDate={value?.end || undefined}
            placeholder="Başlangıç"
          />
        </div>
        <span style={{
          color: 'var(--color-text-tertiary)',
          fontSize: 'var(--text-sm)'
        }}>
          —
        </span>
        <div style={{ flex: 1 }}>
          <DatePicker
            value={value?.end || null}
            onChange={handleEndChange}
            minDate={value?.start || undefined}
            placeholder="Bitiş"
          />
        </div>
      </div>
    </div>
  );
}

export const FilterDateRange = memo(FilterDateRangeComponent);
